import { COLOR_PALETTE } from 'constants/ui';

export const wrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  padding: '24px',
  backgroundColor: ({ palette }) => palette.background.paper,
  borderRadius: '8px',
  boxShadow: ({ palette }) => palette.shadow.m,
};

export const wrapperHeaderStyles = {
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
};

export const titleTypographyStyles = {
  fontSize: '1.8rem',
  fontWeight: 600,
  lineHeight: '2.1rem',
  color: ({ palette }) => palette.text.primary,
};

export const dividerStyles = {
  border: '1px solid',
  borderColor: ({ palette }) => `${palette.border.default} !important`,
  borderBottom: 'none',
  height: 0,
};

export const getAccordionStyles = ({ alwaysExpanded, isOpened }) => ({
  padding: alwaysExpanded ? '0px' : '24px',
  border: `${alwaysExpanded ? 0 : 1}px solid`,
  borderColor: ({ palette }) =>
    `${isOpened ? COLOR_PALETTE.BRAND[6] : palette.border.default} !important`,
  borderRadius: '8px',
  boxShadow: 'none',

  '&.MuiAccordion-root.Mui-expanded': {
    margin: 0,
  },

  '& .MuiAccordionSummary-root': {
    minHeight: '40px',
    padding: 0,
    justifyContent: 'flex-start',
  },

  '& .MuiAccordionSummary-root.Mui-expanded': {
    minHeight: '40px',
    padding: 0,
    marginBottom: '12px',
    justifyContent: 'flex-start',
  },

  '& .MuiAccordionDetails-root': {
    padding: alwaysExpanded ? '0px' : '0 8px',
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
  },

  '& .MuiAccordionSummary-content, .MuiAccordionSummary-content.Mui-expanded': {
    margin: 0,
    minWidth: 0,
  },

  h3: {
    fontSize: 16,
    fontWeight: 700,
    color: ({ palette }) => palette.text.secondary,
  },

  '&:before': {
    height: 0,
  },
});

export const summariesOfTransactionsStyles = {
  backgroundColor: ({ palette }) => palette.background.hoverDefault,
  color: ({ palette }) => palette.text.primary,
  margin: '5px 0',
  padding: '8px 12px',
  borderRadius: '8px',
  fontWeight: 700,
  fontSize: '16px',
};
